import React from 'react'
import { connect } from 'react-redux'

import { Container } from '../../../components/Layout'
import ChangePasswordForm from '../ChangePasswordForm'

const ChangePasswordFormModalComponent = props => {
  const { modalConfirm } = props

  return (
    <Container paddingTop paddingBottom className="sm">
      <ChangePasswordForm closeModal={modalConfirm} />
    </Container>
  )
}

const stateToProps = () => ({})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(ChangePasswordFormModalComponent)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/ChangePasswordFormModal/ChangePasswordFormModal.jsx